import { Add as AddRecipient } from './Add';

export default AddRecipient;
